export default __webpack_public_path__ + "static/media/img-0332-botswana-half-face.8d3b5bf5.png";